import React, { useEffect, useState, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config/config';
import PaymentModal from "../components/ExpensePaymentModal";
import EditInvoiceModal from "../components/EditExpenseModal";
import { useNavigate } from 'react-router-dom';
import DynamicNav from "../config/dynamicNav";
import { 
  Typography, 
  Box, 
  CircularProgress,
  Paper,
  Grid,
  Chip,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Divider,
  Skeleton,
  IconButton,
  Alert,
  Snackbar,
  Tooltip,
  Badge,
  Avatar,
   Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  useTheme
} from '@mui/material';
import { 
  ReceiptLong, 
  History, 
  FileDownload, 
  Print, 
  Mail, 
  Payment, 
  Check, 
  Warning, 
  ErrorOutline,
  InsertDriveFile,
  CalendarToday,
  ArrowUpward,
  ArrowDownward,
  FilterList
} from '@mui/icons-material';
import '../index.css';
import TopBar from "../components/TopBar";
import SideBar from "../components/SideBar";

// Custom invoice status component with enhanced styling
const InvoiceStatus = ({ status }) => {

  const statusConfig = {
    paid: { color: 'success', icon: <Check fontSize="small" />, label: 'Paid' },
    pending: { color: 'warning', icon: <Warning fontSize="small" />, label: 'Pending' },
    overdue: { color: 'error', icon: <ErrorOutline fontSize="small" />, label: 'Overdue' },
    draft: { color: 'default', icon: <InsertDriveFile fontSize="small" />, label: 'Draft' },
  };

  const config = statusConfig[status.toLowerCase()] || statusConfig.pending;

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size="small"
      sx={{
        borderRadius: '8px',
        transition: 'transform 0.2s ease',
        '&:hover': { transform: 'scale(1.05)' },
      }}
    />
  );
};

// Format currency values consistently
const formatCurrency = (amount, currency = 'USD') => {
 return new Intl.NumberFormat('en-KE', {
  style: 'currency',
  currency: 'KES',
  minimumFractionDigits: 2
}).format(amount);

};

// Format dates consistently
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  const options = { month: 'short', day: '2-digit', year: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};



const StudentInvoicesLayout = () => {
  const { id, invoice_id } = useParams();
const navigate = useNavigate();
  const theme = useTheme();
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
  const [studentInfo, setStudentInfo] = useState(null);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
  const [latestInvoice, setInvoiceLatest] = useState(null);
  const [previousInvoices, setPreviousInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [invoicesData, setInvoicesData] = useState([]);
  const [getInvoiceItems, setInvoiceItems] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [getEditInvoiceItems, setEditInvoiceItems] = useState([]);
  const [invoiceInfo, setInvoiceInfo] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentInputs, setPaymentInputs] = useState({});
  const [selected_id,setSelectedId]=useState('');

  const token = localStorage.getItem('token');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEditOpen, setEditModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const handleMarkPaid = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);
  const handleEditModalClose = () => setEditModalOpen(false);

  

  const proceedToAsset = () =>{
      navigate(`/Assets_/${selected_id}`);
  }
const handleViewActions = (id) => {
  setShowModal(true);
  setSelectedId(id);
 // navigate(`/Assets_/${id}`);
}

// Get the token from localStorage
const getToken = () => localStorage.getItem('token');
const token_ = getToken();
// API base URL (use environment variable or fallback)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || config.API_URL+'/api';

const handleSubmitPayment = async (payload) => {
 
  try {
      const token = localStorage.getItem("token");

    // 1. Fetch CSRF cookie
    await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
      withCredentials: true,
    });

    // 2. Get CSRF token
    const xsrfToken = getCookie('XSRF-TOKEN');
    if (!xsrfToken) {
      throw new Error('CSRF token not found');
    }

    // 3. Send request
    const response = await axios.post(
      `${config.API_URL}/api/saveExpensePayments`,
      payload, // Use the payload directly
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-XSRF-TOKEN': xsrfToken,
        },
        withCredentials: true,
      }
    );

 

    const data = response.data;
   
    //window.location.assign(`/students/${payload.invoice_id}/invoices/${payload.invoice_id}`);
     window.location.assign(`/viewexpense/${payload.invoice_id}`);
      setNotification({
      open: true,
      message: data.message || "Payment saved successfully.",
      severity: 'success',
    });
    return { success: true, message: data.message || "Payment saved successfully." };


  } catch (error) {
    return { success: false, message: error.message || "Network error." };
  }
};


const handleEditSubmitPayment = async (payload) => {
  const token = localStorage.getItem("token");

  try {
    //console.log("Payload before submit", payload);

      const token = localStorage.getItem("token");

      // 1. Fetch CSRF cookie
      await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });

      // 2. Get CSRF token
      const xsrfToken = getCookie('XSRF-TOKEN');
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }

      // 3. Send the request with proper Content-Type and credentials
      const response = await fetch(`${config.API_URL}/api/saveExpenseChanges`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-XSRF-TOKEN': xsrfToken,
        },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

    //const response = await response.data();

   /** if (!response.ok) {
      let message = "Failed to save expense.";
      try {
        const json = JSON.parse(text);
        message = json.message || message;
      } catch (_) {
        if (text) message = text;
      }
      return { success: false, message };
    }**/

    // Parse only if response body exists
   // const data = response ? JSON.parse(response) : {};
   // window.location.assign('/viewexpense/'+id);
   // return { success: true, message: data.message || "Payment saved successfully." };


  } catch (error) {
    return { success: false, message: error.message || "Network error." };
  }
};

 const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  };

const handleEditModal = async (item_id) => {
 // //console.log(item_id);
  setEditModalOpen(true);
  const token = localStorage.getItem("token");
  setLoading(true);
    try {
      const res = await api.get(config.API_URL+`/api/pullExpenseItem/${item_id}`);
     setInvoiceItems(res.data.invoice_items);

    // //console.log(res.data.invoice_items);
    } catch (err) {
      //console.error('Error fetching invoices:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
};



  // Create axios instance with auth headers
  const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

   useEffect(() => {
    //get studentinvoice
   axios.get(config.API_URL+`/api/studentExpense/${id}`, {
  headers: {
    Authorization: `Bearer ${token_}`
  }
})
.then(response => {
  setInvoiceInfo(response.data);
})
.catch(error => {
  //console.error('Error fetching invoice info:', error);
});




axios.get(config.API_URL+`/api/latestExpenseV2/${id}`, {
  headers: {
    Authorization: `Bearer ${token_}`
  }
})
.then(response => {
  setInvoiceLatest({
    id: response.data.id,
    customer_id: response.data.customer_id,
    invoiceNumber: response.data.invoiceNumber,
    invoiceIssueDate: response.data.invoiceIssueDate,
    invoiceDueDate: response.data.invoiceDueDate,
    invoiceAmount: response.data.invoiceAmount,
    status: response.data.status,
    raw: response.data.invoice, // optional
  });

  setInvoiceItems(response.data.invoice_items); // 👈 Actual items here
  setPreviousInvoices(response.data.otherInvoices);
  setAccounts(response.data.accounts);
})
.catch(error => {
  //console.error('Error fetching expense info:', error);
});



}, [id]);

  // Add auth token to requests
  api.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Fetch student info
  const fetchStudentInfo = useCallback(async () => {
    try {
      const res = await api.get(`/studentInvoiceInfo/${id}`);
      setStudentInfo(res.data);
    } catch (err) {
      //console.error('Error fetching student info:', err);
    }
  }, []);

  

  // Fetch invoices data
  const fetchInvoices = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const res = await api.get(`/student/${id}/invoices`);
      setInvoicesData(res.data.data);
      processInvoicesData(res.data.data);
    } catch (err) {
      //console.error('Error fetching invoices:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  // Mark invoice as paid
  const markAsPaid = async (invoiceId) => {
    try {
      await api.patch(`/invoices/${invoiceId}`, { status: 'paid' });
      setNotification({
        open: true,
        message: 'Invoice marked as paid successfully',
        severity: 'success'
      });
      fetchInvoices();
    } catch (err) {
      //console.error('Failed to update invoice status:', err);
      setNotification({
        open: true,
        message: 'Failed to update invoice status',
        severity: 'error'
      });
    }
  };

  // Send invoice reminder
  const sendReminder = async (invoiceId) => {
    try {
      await api.post(`/invoices/${invoiceId}/send-reminder`);
      setNotification({
        open: true,
        message: 'Payment reminder sent successfully',
        severity: 'success'
      });
    } catch (err) {
      //console.error('Failed to send payment reminder:', err);
      setNotification({
        open: true,
        message: 'Failed to send payment reminder',
        severity: 'error'
      });
    }
  };

  // Process invoices data based on sort configuration
  const processInvoicesData = useCallback((data) => {
    if (!data || data.length === 0) {
      //setLatestInvoice(null);
     // setPreviousInvoices([]);
      return;
    }
    
    const sortedInvoices = [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
    
   // setLatestInvoice(sortedInvoices[0]);
   // setPreviousInvoices(sortedInvoices.length > 1 ? sortedInvoices.slice(1) : []);
  }, [sortConfig]);




const handleViewInvoice = (id, invoiceId) => {
  if (loading) return; // Prevent multiple requests
  setLoading(true);
//console.log(id);
//console.log(invoiceId);
  axios.get(config.API_URL+`/api/latestInvoice/${id}/${invoiceId}`, {
    headers: {
      Authorization: `Bearer ${token_}`
    }
  })
  .then(response => {
    setInvoiceLatest({
      invoiceNumber: response.data.invoiceNumber,
      invoiceIssueDate: response.data.invoiceIssueDate,
      invoiceDueDate: response.data.invoiceDueDate,
      invoiceAmount: response.data.invoiceAmount,
      status: response.data.status,
      raw: response.data.invoice,
    });

    setInvoiceItems(response.data.invoice_items);
    setPreviousInvoices(response.data.otherInvoices);
  })
  .catch(error => {
    //console.error('Error fetching specific invoice info:', error);
  })
  .finally(() => {
    setLoading(false); // Always stop loading
  });
};



  // Handle download invoice
  const handleDownloadInvoice = (invoiceId) => {
    setNotification({
      open: true,
      message: 'Expense download started',
      severity: 'info'
    });
    window.open(`${config.API_URL}/downloadExpense/${id}/${token}`);
  };

  // Handle printing invoice
  const handlePrintInvoice = (invoiceId) => {
    setNotification({
      open: true,
      message: 'Preparing expense for printing',
      severity: 'info'
    });
    window.open(`${config.API_URL}/downloadExpense/${id}/${token}`);
  };

  // Handle sort click
  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
  
  // Re-process invoices when sort configuration changes
  useEffect(() => {
    if (invoicesData.length > 0) {
      processInvoicesData(invoicesData);
    }
  }, [sortConfig, invoicesData, processInvoicesData]);

  // Fetch data on component mount
  useEffect(() => {
    fetchStudentInfo();
    fetchInvoices();
  }, []);

  // Calculate total amounts
  const calculateTotals = (invoices) => {
    if (!Array.isArray(invoices) || invoices.length === 0) {
      return { total: 0, paid: 0, pending: 0, overdue: 0 };
    }
    
    return invoices.reduce(
      (acc, invoice) => {
        acc.total += invoice.amount;
        if (invoice.status.toLowerCase() === 'paid') {
          acc.paid += invoice.amount;
        } else if (invoice.status.toLowerCase() === 'overdue') {
          acc.overdue += invoice.amount;
        } else {
          acc.pending += invoice.amount;
        }
        return acc;
      },
      { total: 0, paid: 0, pending: 0, overdue: 0 }
    );
  };

  const totals = calculateTotals(invoicesData);

  // Close notification
  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };


  const handleSavePayment = () => {
  const payload = {
    invoiceId: latestInvoice.id, // or the actual invoice ID
    payments: Object.entries(paymentInputs).map(([itemId, amount]) => ({
      item_id: itemId,
      amount_paid: amount,
    })),
  };

  axios.post(config.API_URL+'/api/payInvoice', payload, {
    headers: { Authorization: `Bearer ${token_}` },
  })
  .then(response => {
    alert('Payment saved!');
    setShowPaymentModal(false);
    // Optional: Refresh invoice info
  })
  .catch(error => {
    //console.error('Payment error:', error);
    alert('Error saving payment.');
  });
};


   

  // Display skeletons when loading
  if (loading) {
    return (
      <div className="d-flex flex-column" id="kt_app_root">
        <TopBar />
        <div className="d-flex flex-grow-1">
          <SideBar />
          <div className="flex-grow-1 p-4">
            <Box p={3}>
              <Skeleton variant="rectangular" height={50} width="50%" sx={{ mb: 2, borderRadius: '8px' }} />
              <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={12} md={6}>
                  <Skeleton variant="rectangular" height={160} sx={{ borderRadius: '12px' }} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Skeleton variant="rectangular" height={160} sx={{ borderRadius: '12px' }} />
                </Grid>
              </Grid>
              <Skeleton variant="rectangular" height={40} sx={{ mb: 2, borderRadius: '8px' }} />
              <Skeleton variant="rectangular" height={300} sx={{ borderRadius: '12px' }} />
            </Box>
          </div>
        </div>
      </div>
    );
  }

    if (loading) {
      return (
            `<div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
              <CircularProgress />
            </div>`
      );
    }

  // Display error state
  if (error) {
    return (
      <div className="d-flex flex-column" id="kt_app_root">
        <TopBar />
        <div className="d-flex flex-grow-1">
          <SideBar />
          <div className="flex-grow-1 p-4">
            <Alert
              severity="error"
              sx={{
                m: 3,
                borderRadius: '12px',
                bgcolor: '#FFF1F2',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              }}
            >
              Error loading expenses. Please try again later or contact support.
            </Alert>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column" id="kt_app_root">
      <TopBar />

      <div className="d-flex flex-grow-1">
        <SideBar />
        <div className="flex-grow-1 p-4">
        <DynamicNav/>
          <Box
            p={3}
            sx={{
              bgcolor: 'background.default',
              minHeight: '100vh',
            }}
          >
            {/* Page header with student info */}

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={3}
              sx={{ bgcolor: 'background.paper', p: 2, borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
            >
              <Box>
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  gutterBottom
                  sx={{ color: '#2D3748' }}
                >
                  Expenses Management
                </Typography>
                {studentInfo && (
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="h6"
                      sx={{ color: '#718096' }}
                    >
                     
                    </Typography>
                  </Box>
                )}
              </Box>
             
            </Box>
             {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-md w-full p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-semibold text-gray-900">
                  Recognize expense as an asset
                </h3>
               
              </div>
              
              <div className="flex space-x-4 mt-6">
                <button
                  onClick={(e)=>setShowModal(false)}
                  className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  onClick={(e)=>proceedToAsset()}
                 
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  Proceed and recognize as asset
                </button>
              </div>
            </div>
          </div>
        )}
            

            {/* Latest Invoice */}
            {latestInvoice && (
              <Box mb={4}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  mb={2}
                  display="flex"
                  alignItems="center"
                  sx={{ color: '#2D3748' }}
                >
                  
                </Typography>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s ease',
                    '&:hover': { transform: 'translateY(-2px)' },
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Expense #:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#718096' }}>
                          {latestInvoice.invoiceNumber}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Issue Date:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#718096' }}>
                          {formatDate(latestInvoice.invoiceIssueDate)}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Due Date:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#718096' }}>
                          {formatDate(latestInvoice.invoiceDueDate)}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Amount:
                        </Typography>
                        <Typography variant="body1" fontWeight="bold" sx={{ color: '#2D3748' }}>
                          {formatCurrency(latestInvoice.invoiceAmount)}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Status:
                        </Typography>
                        <InvoiceStatus status={latestInvoice.status} />
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Description:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#718096' }}>
                          {latestInvoice.note || "--"}
                        </Typography>
                      </Box>
                    </Grid>
                    {/* Invoice Items Table */}
                    <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        fontWeight="medium"
                        mt={3}
                        mb={2}
                        sx={{ color: '#2D3748' }}
                      >
                        Expense Items
                      </Typography>
                      <TableContainer>
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ bgcolor: '#F7FAFC' }}>
                              <TableCell sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                                Description
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                                Quantity
                              </TableCell>
                              
                              <TableCell align="right" sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                                Total
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                                Paid
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                               Balance
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {getInvoiceItems.map((item, index) => (
                              <TableRow
                                key={index}
                                sx={{
                                  bgcolor: index % 2 === 0 ? '#FFFFFF' : '#F7FAFC',
                                  '&:hover': { bgcolor: '#F0E9FF' },
                                }}
                              >
                                <TableCell onClick={(e)=>handleViewActions(item.id)} sx={{ color: '#2D3748' }} className="cursor-pointer" title="View Actions">{item.description}<br/><strong className="text-blue"><u >View Actions</u></strong></TableCell>
                                <TableCell align="right" sx={{ color: '#718096' }} >
                                  {item.quantity}
                                </TableCell>
                              
                                <TableCell align="right" sx={{ color: '#2D3748', fontWeight: 'medium' }}>
                                  {formatCurrency(item.total)}
                                </TableCell>
                                  <TableCell align="right" sx={{ color: '#718096' }}>
                                  {formatCurrency(item.paid)}
                                </TableCell>
                                  <TableCell align="right" sx={{ color: '#718096' }}>
                                  {formatCurrency(item.balance)}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                           <TableBody>
                            <TableRow>
                            <TableCell align="right" sx={{ color: '#718096' }}>
                            </TableCell>
                             <TableCell align="right" sx={{ color: '#718096' }}>
                            </TableCell>
                             <TableCell align="right" sx={{ color: '#718096' }}>
                              <Typography
                          variant="body1"
                          fontWeight="bold"
                          sx={{ color: '#2D3748' }}
                        >
                          Total:{' '}
                          {formatCurrency(
                            getInvoiceItems.reduce((sum, item) => sum + item.total, 0)
                          )}
                        </Typography>
                            </TableCell>
                             <TableCell align="right" sx={{ color: '#718096' }}>
                              <Typography
                          variant="body1"
                          fontWeight="bold"
                          sx={{ color: '#2D3748' }}
                        >
                          Total:{' '}
                          {formatCurrency(
                            getInvoiceItems.reduce((sum, item) => sum + item.paid, 0)
                          )}
                        </Typography>
                            </TableCell>
                             <TableCell align="right" sx={{ color: '#718096' }}>
                              <Typography
                          variant="body1"
                          fontWeight="bold"
                          sx={{ color: '#2D3748' }}
                        >
                          Total:{' '}
                          {formatCurrency(
                            getInvoiceItems.reduce((sum, item) => sum + item.balance, 0)
                          )}
                        </Typography>
                            </TableCell>
                             </TableRow>
                           </TableBody>
                        </Table>
                      </TableContainer>
                     
                    </Grid>
                    <Grid item xs={12}>
                      <Divider sx={{ my: 2, bgcolor: '#E2E8F0' }} />
                      <Box display="flex" justifyContent="flex-end" gap={1}>
                        <Tooltip title="Download Expense">
                          <IconButton
                            color="primary"
                            onClick={() => handleDownloadInvoice(latestInvoice.id)}
                            sx={{
                              transition: 'transform 0.2s ease',
                              '&:hover': { transform: 'scale(1.1)' },
                            }}
                          >
                            <FileDownload />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Print Expense">
                          <IconButton
                            color="primary"
                            onClick={() => handlePrintInvoice(latestInvoice.id)}
                            sx={{
                              transition: 'transform 0.2s ease',
                              '&:hover': { transform: 'scale(1.1)' },
                            }}
                          >
                            <Print />
                          </IconButton>
                        </Tooltip>
                        
                        <Button
                          variant="contained"
                         
                         
                          onClick={() => handleEditModal(latestInvoice.id)}
                          sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            background: 'linear-gradient(45deg, #6B46C1, #3182CE)',
                            color: '#FFFFFF',
                            fontWeight: 500,
                            px: 3,
                            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                            '&:hover': {
                              transform: 'translateY(-2px)',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                              background: 'linear-gradient(45deg, #553C9A, #2B6CB0)',
                            },
                          }}
                        >
                     Edit
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={<Payment />}
                          disabled={latestInvoice.status.toLowerCase() === 'paid'}
                          onClick={handleMarkPaid}
                          sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            background: 'linear-gradient(45deg, #6B46C1, #3182CE)',
                            color: '#FFFFFF',
                            fontWeight: 500,
                            px: 3,
                            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                            '&:hover': {
                              transform: 'translateY(-2px)',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                              background: 'linear-gradient(45deg, #553C9A, #2B6CB0)',
                            },
                          }}
                        >
                     Add Payment
                        </Button>
      <PaymentModal
        open={modalOpen}
        onClose={handleModalClose}
        invoice={latestInvoice.id} // This should come from your fetched data
        invoiceItems={getInvoiceItems}
        accounts={accounts}
        onSubmit={handleSubmitPayment}
      />

      <EditInvoiceModal
        open={modalEditOpen}
        onClose={handleEditModalClose}
        invoice={latestInvoice} // This should come from your fetched data
        invoiceItems={getInvoiceItems}
        onSubmit={handleEditSubmitPayment}
      />
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              </Box>

            )}

           
          </Box>

          {/* Notification system */}
          <Snackbar
            open={notification.open}
            autoHideDuration={6000}
            onClose={handleCloseNotification}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <Alert
              onClose={handleCloseNotification}
              severity={notification.severity}
              sx={{
                width: '100%',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              }}
            >
              {notification.message}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </div>
  );
};

export default StudentInvoicesLayout;